import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGroupedBarplot = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.55775 17.5C2.05258 17.5 1.625 17.325 1.275 16.975C0.925 16.625 0.75 16.1974 0.75 15.6923V0H2.25V15.6923C2.25 15.7692 2.28208 15.8398 2.34625 15.9038C2.41025 15.9679 2.48075 16 2.55775 16H18.25V17.5H2.55775ZM4.19225 14.25V6.09625H7.19225V14.25H4.19225ZM8.94225 14.25V1.09625H11.9423V14.25H8.94225ZM13.6923 14.25V10.0963H16.6923V14.25H13.6923Z",
		fill: "currentColor"
	})
});
export default SvgGroupedBarplot;
